import cognitoAuth from '@/cognito'
import AWS from 'aws-sdk'

class Storage {
  constructor () {
    this.s3 = null
  }

  async init () {
    const token = await cognitoAuth.getIdTokenPromise()

    AWS.config.update({
      region: process.env.VUE_APP_AWS_REGION,
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID,
        Logins: {
          [`cognito-idp.${process.env.VUE_APP_AWS_REGION}.amazonaws.com/${process.env.VUE_APP_COGNITO_USER_POOL_ID}`]: token
        }
      })
    })

    this.s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      params: {
        Bucket: process.env.VUE_APP_S3_BUCKET_FILE_UPLOAD_NAME
      }
    })
  }

  async generatePresignedUrl (bucketName, key, operation, expires = 60 * 5) {
    if (!this.s3) {
      throw new Error('S3 client is not initialized. Call init() first.')
    }

    const params = {
      Bucket: bucketName || this.config.params.Bucket,
      Key: key,
      Expires: expires
    }

    // Add ContentType for PUT operation
    if (operation === 'putObject') {
      params.ContentType = 'application/octet-stream'
    }

    if (operation === 'getObject') {
      params.ResponseContentDisposition = `attachment; filename="${key.split('/').pop()}"`
    }

    try {
      const url = await this.s3.getSignedUrlPromise(operation, params)
      return url
    } catch (error) {
      console.error('Error generating presigned URL:', error)
      throw error
    }
  }

  async uploadFile (path, file) {
    if (!this.s3) {
      await this.init()
    }

    const uploadUrl = await this.generatePresignedUrl(
      process.env.VUE_APP_S3_BUCKET_FILE_UPLOAD_NAME,
      path,
      'putObject',
      60
    )

    try {
      await fetch(uploadUrl, {
        method: 'put',
        body: file
      })

      return {
        bucket: process.env.VUE_APP_S3_BUCKET_FILE_UPLOAD_NAME,
        key: path
      }
    } catch (e) {
      throw new Error(e.message)
    }
  }

  async getFile (key) {
    if (!this.s3) {
      await this.init()
    }

    const downloadUrl = await this.generatePresignedUrl(
      process.env.VUE_APP_S3_BUCKET_FILE_UPLOAD_NAME,
      key,
      'getObject',
      60 * 5
    )

    return downloadUrl
  }

  async deleteFile (key) {
    if (!this.config.region) {
      await this.init()
    }

    const params = {
      Bucket: this.config.params.Bucket,
      Key: key
    }

    try {
      await this.s3.deleteObject(params).promise()
    } catch (e) {
      throw new Error(e.message)
    }
  }
}

Storage.region = process.env.VUE_APP_AWS_REGION

export default Storage
